module.exports = __webpack_public_path__ + "static/media/video-3.44c3c0c7.webm";